import React, { useState, useEffect } from 'react';
import cssClasses from './Dashboard.module.css';
import CustomAutoComplete from '../../Subcomponents/CustomAutoComplete';
import { supabase } from '../../supabaseClient';
import { errorTost } from '../../Services/Toast';
import { dismissLoader, presentLoader } from '../../Services/loader';
import { Box, Grid } from '@mui/material';
import DashboardCard from '../../Subcomponents/DashboardCard/DashboardCard';
import { groupBy, uniqBy } from 'lodash';
import totalTokens from '../../Assets/Images/Dashboard/totalTokens.svg'
import { useSelector } from 'react-redux';

function TotalTokensAnalysis({goBack}) {

    const loggedInUser = useSelector((state) => state.Auth.user);

    const [isLoading, setIsLoading] = useState(false);
    const [eventList, setEventList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState("All");

    const [totalTokensCount, setTotalTokensCount] = useState(0);
    const [preSelectedToken, setPreSelectedToken] = useState(null);    
    const [priorityPassToken, setPriorityPassToken] = useState(null);
    const [otherToken, setOtherToken] = useState(null);    
    const [refundRequested, setRefundRequested] = useState(null);
    
    useEffect(() => {
        supabase.from('Events').select('*').eq("isPublished", true).then(res => {
            console.log("res => ", res);
            if (res.data) {
                setSelectedEvent("All");
                setEventList([...res.data]);
                // getAnalysisDataFromServer();
            }
        })
    }, [])
    
    useEffect(() => {
        if (selectedEvent) {
            getAnalysisDataFromServer();
        }
    }, [selectedEvent]);

    async function getAnalysisDataFromServer() {

        presentLoader();
        setIsLoading(true);
        let teamIds = [];
        if (loggedInUser?.roleId?.accessibleTabs?.Dashboard?.All?.["Show All Analysis"]?.show === "Team wise") {
            teamIds = JSON.parse(localStorage.getItem('teamIds'));
        }
        
        try {
            let supabaseQuery = supabase.from("EventTokenLeadRelations").select("*, leadId(*), eventTokenId(*, tokenId(*))");
            let supabaseQueryForRefundRequested = supabase.from("EventTokenLeadRelations").select("*, leadId(*), eventTokenId(*, tokenId(*))");

            if (selectedEvent !== "All") {
                let _selectedTokenId = eventList.find(f => f.title === selectedEvent)?.eventId;
                if (_selectedTokenId) {
                    supabaseQuery = supabaseQuery.eq("eventId", _selectedTokenId);
                    supabaseQueryForRefundRequested = supabaseQueryForRefundRequested.eq("eventId", _selectedTokenId);
                }
            }
            if(teamIds?.length > 0) {
                supabaseQuery = supabaseQuery.in("leadId.userId", teamIds);
                supabaseQueryForRefundRequested = supabaseQueryForRefundRequested.in("leadId.userId", teamIds);
            }

            const analysisDataResponse = await supabaseQuery.eq("isPrerequisiteUsed", false).gt("paidAmount", 0).neq("status", "refund requested");
            const supabaseQueryForRefundRequestedDataResponse = await supabaseQueryForRefundRequested.eq("isPrerequisiteUsed", false).gt("paidAmount", 0).eq("status", "refund requested");

            console.log("analysisDataResponse => ", analysisDataResponse);

            if (analysisDataResponse?.data) {
                const _preSelectedToken = analysisDataResponse?.data.filter(f => f?.eventTokenId?.tokenId?.isPreselect);
                const _priorityPassToken = analysisDataResponse?.data.filter(f => f?.eventTokenId?.tokenId?.isPriorityPass);
                const _otherToken = analysisDataResponse?.data.filter(f => !f?.eventTokenId?.tokenId?.isPreselect && !f?.eventTokenId?.tokenId?.isPriorityPass);

                setPreSelectedToken(groupBy(_preSelectedToken, tokenItem => tokenItem?.eventTokenId?.tokenId?.name));
                setPriorityPassToken(groupBy(_priorityPassToken, tokenItem => tokenItem?.eventTokenId?.tokenId?.name));
                setOtherToken(groupBy(_otherToken, tokenItem => tokenItem?.eventTokenId?.tokenId?.name));
            } else {
                throw analysisDataResponse;
            }
            if (supabaseQueryForRefundRequestedDataResponse.data) {
                setRefundRequested(groupBy(supabaseQueryForRefundRequestedDataResponse.data, tokenItem => tokenItem?.eventTokenId?.tokenId?.name))
            }     
            setTotalTokensCount((analysisDataResponse?.data?.length || 0) + (supabaseQueryForRefundRequestedDataResponse?.data?.length || 0));

            dismissLoader();
            setIsLoading(false);
        } catch (error) {
            console.log("analysisDataResponse error => ", error);
            if (error?.error?.message) {
                errorTost(error?.error?.message);
            } else {
                errorTost("Something went wrong! Try again");
            }
            dismissLoader();
            setIsLoading(false);
        }
    }

    // console.log("refundRequested => ", refundRequested);

    return (
        <div>
            <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} flexWrap={"wrap"}>
                <div style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '5rem',
                    // marginBottom: '2rem',
                    flex: 1
                }}>
                    <p className={cssClasses.button} onClick={() => { goBack() }}>Back</p>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2rem',
                        width: '100%',
                    }}>
                        <p style={{ fontSize: '2rem' }}>Events&nbsp;:</p>
                        <div style={{ width: 'min(250px, 100%)' }}>
                            <CustomAutoComplete 
                                NoOptionsText={'No events found'}
                                InitialValue={(e) => {
                                    if (!e) {
                                        setSelectedEvent("All");
                                    } else {
                                        setSelectedEvent(e);
                                    }
                                }}
                                list={["All", ...eventList.map(m => m?.title)]}
                                multiple={false} disable={false}
                                value={selectedEvent}
                            />
                        </div>
                    </div>
                </div>
                
                <p style={{ marginTop: '2rem', fontSize: "2rem" }} className={cssClasses.totalCountsHeader}>Total: {totalTokensCount}</p>
            </Box>


            <div className={cssClasses.totalCountsDiv}>
                { preSelectedToken && (Object.keys(preSelectedToken).length > 0) &&
                    <>
                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Pre-Selected Tokens</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            {
                                Object.keys(preSelectedToken).map(preSelectedTokenItem => (
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={preSelectedToken[preSelectedTokenItem]?.length} title={preSelectedTokenItem} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
                }
                { priorityPassToken && (Object.keys(priorityPassToken).length > 0) &&
                    <>
                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Priority Pass Tokens</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            {
                                Object.keys(priorityPassToken).map(priorityPassTokenItem => (
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={priorityPassToken[priorityPassTokenItem]?.length} title={priorityPassTokenItem} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
                }
                { otherToken && (Object.keys(otherToken).length > 0) &&
                    <>
                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Tokens</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            {
                                Object.keys(otherToken).map(otherTokenItem => (
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={otherToken[otherTokenItem]?.length} title={otherTokenItem} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
                }

                { refundRequested && (Object.keys(refundRequested).length > 0) &&
                    <>
                        <p style={{ marginTop: '2rem' }} className={cssClasses.countsHeader}>Refund Requested Tokens</p>
                        <Grid container spacing={{ xs: 2, md: 3, lg: 3 }} columns={{ xs: 8, sm: 12, md: 12, lg: 20 }}>
                            {
                                Object.keys(refundRequested).map(refundRequestedTokenItem => (
                                    <Grid className={cssClasses.Grid} item xs={4} sm={4} md={4} lg={4}>
                                        <DashboardCard icon={totalTokens} number={refundRequested[refundRequestedTokenItem]?.length} title={refundRequestedTokenItem} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
                }

            </div>
        </div>
    )
}

export default TotalTokensAnalysis